import { createContext } from 'react';

import { HttpProviderContext } from './typesHttp';

export const HttpContext = createContext({} as HttpProviderContext);
